import styled from "styled-components";

export const EmptyShipments = styled.p`
  margin: 5px 0;
  color: ${(props) => props.theme.black50};
`;
